import React from 'react'
import Box from '@mui/material/Box';
import profileModule from './profile.module.css'
import { styled, Typography, Container } from '@mui/material';

const Image = styled("img")({
    boxShadow: "0px 0px 0px 8px rgba(0, 0, 0, 0.09),0px 0px 0px 0px rgba(0, 0, 0, 0.14),0px 0px 0px 0px rgba(0, 0, 0, 0.12)"
});

function Profile() {
    return (
        <>
            <Box component={"section"}>
                <Box className={profileModule.profileBanner} sx={{ position: 'relative' }}>
                    <Box sx={{ borderRadius: 100, p: 1, position: "absolute", bottom: -140, left: 100, display: "flex", width: "270px", height: "270px", bgcolor: "white" }}>
                        <Image src="/assets/images/profile-image.webp" alt="User" width={'100%'} height={"100%"} sx={{ bgcolor: "white", borderRadius: 100 }} />
                    </Box>
                </Box>
                <Container maxWidth="xl" sx={{ py: 1, pb: 20}}>
                    <Typography variant="h4" color="primary" ml={45} fontWeight={'bold'}>
                        Admin
                    </Typography>
                    <Typography variant="h5" color="primary" ml={45} >
                    Manager of Mortgage Street
                    </Typography>
                    <Typography variant="body1" color="primary" ml={45} >
                    Mortgage Street Pty Ltd
                    </Typography>                    
                </Container>

            </Box>
        </>
    )
}

export default Profile;